<template>
  <v-card
    class="d-flex justify-start ma-0 my-2"
    :class="[$vuetify.breakpoint.smAndDown ? 'row mx-4' : 'pl-4']"
    flat
  >
    <v-card
      :class="[
        'rectangle',
        { 'ml-3': i != 0 && $vuetify.breakpoint.mdAndUp },
        { 'col-12 mb-4': $vuetify.breakpoint.smAndDown },
        'col-3'
      ]"
      v-for="(item, i) in road"
      :key="i"
    >
      <div>
        <p class="subtitle-2 ma-0 pa-0">{{ item.name }}</p>
      </div>
      <div>
        <div class="outline-menu">
          <v-img class="menu" :src="item.icon"></v-img>
        </div>
      </div>
      <div class="stat">
        <p class="font-weight-medium my-0 title number">{{ item.today | numFormat }}</p>
        <p class="subtitle-2 my-0">ครั้ง</p>
      </div>
      <v-row class="ma-0">
        <v-col cols="6" class="pa-0">
          <div class="text-center">
            <v-img
              contain
              height="34.5"
              :src="require('@/assets/icons/death.svg')"
              class="ma-0 mt-2"
            ></v-img>
            <!-- <i :class="`fas fa-dizzy fa-2x`" class="ma-0 mt-2"></i> -->
          </div>
          <p class="font-weight-medium subtitle-1 my-0">{{ item.dead | numFormat }}</p>
          <p class="subtitle-2 my-0">คน</p>
        </v-col>
        <v-col cols="6" class="pa-0">
          <div class="text-center">
            <i :class="`fas fa-user-injured fa-2x`" class="ma-0 mt-2"></i>
          </div>
          <p class="font-weight-medium subtitle-1 my-0">{{ item.injury | numFormat }}</p>
          <p class="subtitle-2 my-0">คน</p>
        </v-col>
      </v-row>
    </v-card>
  </v-card>
</template>

<script>
export default {
  name: 'Today',
  data: () => ({
    road: []
  }),
  props: {
    searchParams: {
      type: Object,
      default: {}
    },
    summary: {
      type: Object,
      default: {}
    }
  },
  created() {
    this.getInitRoad();
  },
  mounted() {},
  watch: {
    searchParams() {
      this.getRoad();
    },
    summary(val) {
      let other_accident = val.accident.summary;
      let other_dead = val.dead.summary;
      let other_injury = val.injury.summary;
      const propname = ['doh', 'drr', 'exat'];
      for (let index = 0; index < propname.length; index++) {
        const element = this.road[index];
        other_accident -= element.today;
        other_dead -= element.dead;
        other_injury -= element.injury;
      }
      this.road[3].today = other_accident;
      this.road[3].dead = other_dead;
      this.road[3].injury = other_injury;
    }
  },
  methods: {
    getInitRoad() {
      this.road = [
        {
          name: 'ทางหลวง',
          code: 'doh',
          icon: require('@/assets/icons/government_doh.svg'),
          today: 0,
          dead: 0,
          injury: 0
        },
        {
          name: 'ทางหลวงชนบท',
          code: 'drr',
          icon: require('@/assets/icons/government_drr.svg'),
          today: 0,
          dead: 0,
          injury: 0
        },
        {
          name: 'ทางพิเศษ',
          code: 'motorway',
          icon: require('@/assets/icons/government_motorway.svg'),
          today: 0,
          dead: 0,
          injury: 0
        },
        {
          name: 'ทางท้องถิ่น',
          code: 'local',
          icon: require('@/assets/icons/local_road.svg'),
          today: 0,
          dead: 0,
          injury: 0
        }
      ];
    },
    getRoad() {
      const scope = this;
      this.getInitRoad();
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/dashboard/network/road`;

      this.axios
        .get(url, { params: this.searchParams })
        .then(response => {
          if (response.status == 200 && response.data.data) {
            const { data } = response.data;
            const propname = ['doh', 'drr', 'exat'];
            for (let index = 0; index < propname.length; index++) {
              const element = data[propname[index]];
              scope.road[index].today = element.amount;
              scope.road[index].dead = element.dead;
              scope.road[index].injury = element.injury;
            }
            // console.warn(data);
            // scope.road.forEach(item => {
            //   item.today = data[item.code]['today'];
            //   item.dead = data[item.code]['dead'];
            //   item.injury = data[item.code]['injury'];
            // });
            if (scope.summary) {
              let other_accident = scope.summary.accident ? scope.summary.accident.summary : 0;
              let other_dead = scope.summary.dead ? scope.summary.dead.summary : 0;
              let other_injury = scope.summary.injury ? scope.summary.injury.summary : 0;
              for (let index = 0; index < propname.length; index++) {
                const element = data[propname[index]];
                other_accident -= element.amount;
                other_dead -= element.dead;
                other_injury -= element.injury;
              }
              scope.road[3].today = other_accident;
              scope.road[3].dead = other_dead;
              scope.road[3].injury = other_injury;
            }
          }
        })
        .catch(function(error) {
          scope.yearItems = [];
          console.log(error);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.box {
  height: 100%;
  display: grid;
}

.col {
  padding-top: 0;
  padding-bottom: 0;
}

.col .img {
  padding: 0;
}

.card {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);
  border-radius: 3px;
  margin-top: 15px;
}

.stat {
  background-color: white;
  margin: auto;
}

.number {
  color: #ba4438;
  text-align: center;
}

p {
  text-align: center;
}

.outline-menu {
  height: 100%;
  text-align: center;
}

.menu {
  width: 48px;
  height: 48px;
  margin: auto;
  top: calc(50% - 24px);
}

.sub-menu {
  width: 32px;
  height: 32px;
  margin: auto;
  top: calc(50% - 16px);
}

.rectangle {
  // width: 180px;
  height: 240px;
  border-radius: 3px;
  border: solid 1px #979797;
}
</style>
